import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-x2 mb-0" }, "Đổi mật khẩu", -1)
const _hoisted_2 = {
  key: 0,
  class: "text-muted mb-4"
}
const _hoisted_3 = { class: "d-flex flex-column align-items-start w-100 mb-3" }
const _hoisted_4 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_5 = { class: "d-flex justify-content-end gap-2 mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LabelCustom = _resolveComponent("LabelCustom")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.isVisible,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isVisible) = $event)),
    width: "480px",
    onClose: _ctx.onClose
  }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      (_ctx.userName)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
            _createTextVNode(" Người dùng: "),
            _createElementVNode("strong", null, _toDisplayString(_ctx.userName), 1)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_el_form, {
        ref: "formRef",
        model: _ctx.form,
        rules: _ctx.rules,
        onSubmit: _withModifiers(_ctx.submit, ["prevent"])
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_LabelCustom, { "is-required": "" }, {
              default: _withCtx(() => [
                _createTextVNode("Mật khẩu mới")
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              prop: "mat_khau",
              class: "mb-0 w-100"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.mat_khau,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.mat_khau) = $event)),
                  type: "password",
                  "show-password": "",
                  placeholder: "Nhập mật khẩu mới",
                  name: "mat_khau"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_LabelCustom, { "is-required": "" }, {
              default: _withCtx(() => [
                _createTextVNode("Xác nhận mật khẩu")
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              prop: "mat_khau_confirm",
              class: "mb-0 w-100"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.mat_khau_confirm,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.mat_khau_confirm) = $event)),
                  type: "password",
                  "show-password": "",
                  placeholder: "Nhập lại mật khẩu mới",
                  name: "mat_khau_confirm"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_ButtonCustom, {
              "button-type": _ctx.ButtonsType.CANCEL,
              "color-type": _ctx.ButtonTypeColors.SECONDARY,
              onClick: _ctx.onClose
            }, {
              "button-label": _withCtx(() => [
                _createTextVNode("Hủy")
              ]),
              _: 1
            }, 8, ["button-type", "color-type", "onClick"]),
            _createVNode(_component_ButtonCustom, {
              "button-type": _ctx.ButtonsType.SAVE,
              "color-type": _ctx.ButtonTypeColors.SUCCESS,
              disabled: _ctx.loading,
              "is-loading": _ctx.loading,
              onClick: _ctx.submit
            }, {
              "button-label": _withCtx(() => [
                _createTextVNode("Lưu")
              ]),
              _: 1
            }, 8, ["button-type", "color-type", "disabled", "is-loading", "onClick"])
          ])
        ]),
        _: 1
      }, 8, ["model", "rules", "onSubmit"])
    ]),
    _: 1
  }, 8, ["modelValue", "onClose"]))
}